module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_ohsu-7849a352b170e7971717c15da53f3c6b.png";